import React, { lazy, useEffect, useState } from 'react'
import { ConnectedRouter } from 'connected-react-router'
import { Switch } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { GlobalStyle } from './GlobalStyle'
import { history } from '../../utils/history'
import { AuthRoute } from './AuthRoute'
import * as route from '../../routes'
import { SuspenceFallback } from './SuspanceFallback'
import { OnlyUnauthRoute } from './OnlyUnauthRoute'
import { isLoggedIn } from '../../features/session/selector'
import { SessionActions } from '../../features/session/actions'
import { cookies } from '../../features/session/reducer'
import Themes from '../../pages/Themes'
import Hooks from '../../pages/Hooks'
import AddTheme from '../../pages/Themes/ThemeWizard'
import AddHook from '../../pages/Hooks/HookWizard'
import Profiles from '../../pages/Profiles'
import Stats from '../../pages/Stats'
import UserChats from '../../pages/UserChats'
// import { session } from '../../features/session/selector'

const Dashboard = lazy(() => import('../../pages/Dashboard'))
const Login = lazy(() => import('../../pages/Login'))

const App = () => {
  const isUserLoggedIn = useSelector(isLoggedIn)
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    function checkSession() {
      const uid = cookies.get('uid')
      if (uid) {
        dispatch(SessionActions.restoreSession())
      }
      setLoading(false)
    }
    checkSession()
  }, [dispatch])

  if (loading) {
    return <div>loading</div>
  }

  return (
    <ConnectedRouter history={history}>
      <SuspenceFallback>
        <Switch>
          <AuthRoute loggedIn={isUserLoggedIn} path={route.DASHBOARD} exact component={Dashboard} />
          <AuthRoute loggedIn={isUserLoggedIn} exact path={route.THEMES} component={Themes} />
          <AuthRoute loggedIn={isUserLoggedIn} exact path={route.HOOKS} component={Hooks} />
          <AuthRoute loggedIn={isUserLoggedIn} exact path={route.PROFILES} component={Profiles} />
          <AuthRoute loggedIn={isUserLoggedIn} exact path={route.STATS} component={Stats} />
          <AuthRoute loggedIn={isUserLoggedIn} exact path={route.USER_CHATS} component={UserChats} />
          <AuthRoute loggedIn={isUserLoggedIn} exact path={route.THEME_DETAIL} component={AddTheme} />
          <AuthRoute loggedIn={isUserLoggedIn} exact path={route.ADD_THEME} component={AddTheme} />
          <AuthRoute loggedIn={isUserLoggedIn} exact path={route.HOOK_DETAIL} component={AddHook} />
          <AuthRoute loggedIn={isUserLoggedIn} exact path={route.ADD_HOOK} component={AddHook} />
          <OnlyUnauthRoute loggedIn={isUserLoggedIn} path={route.LOGIN} redirect={route.DASHBOARD} component={Login} />
        </Switch>
      </SuspenceFallback>

      <GlobalStyle />
    </ConnectedRouter>
  )
}

// eslint-disable-next-line import/no-default-export
export default App
